import { z } from 'zod';
import { StringSchema } from '../../common';

export const CreateMiniGameInputSchema = z.object({
    startDate: z.number().int().positive(),
    endDate: z.number().int().positive(),
    link: StringSchema,
    title: StringSchema,
    imageUrl: StringSchema.optional(),
    setNumber: z.number().int().positive(),
});

export const UpdateMiniGameInputSchema = z.object({
    id: StringSchema,
    startDate: z.number().int().positive().optional(),
    endDate: z.number().int().positive().optional(),
    link: StringSchema.optional(),
    title: StringSchema.optional(),
    imageUrl: StringSchema.optional(),
    setNumber: z.number().int().positive().optional(),
});

export const DeleteMiniGameInputSchema = z.object({
    id: StringSchema,
});

export const GetMiniGameByIdInputSchema = z.object({
    id: StringSchema,
});

export const UpdateMiniGameSetInputSchema = z.object({
    currentSetNumber: z.number().int().positive(),
    newSetNumber: z.number().int().positive().optional(),
    startDate: z.number().int().positive().optional(),
    endDate: z.number().int().positive().optional(),
});
